<template>
  <div class="certificate">
    <div class="certificate-bar" :style="color" v-if="color !== ''">
      {{ $t("dashboard.certificateMsg") }} {{ daysLeft }}
      {{ $t("dashboard.certificateMsg2") }}
      <a
        class="certificate-link"
        href="https://wa.me/554799541307"
        target="_blank"
        rel="noopener noreferrer"
      >
        <b>WhatsApp (47) 99954-1307</b>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  computed: {
    ...mapGetters(["certificates"]),

    daysLeft: function() {
      let certs = this.certificates;
      if (!certs || !certs.useCertificate) return 365;

      const cdate = this.moment().utc();

      let daysleft = 0;
      if (certs.current && certs.current.validTo)
        daysleft = this.moment(new Date(certs.current.validTo)).diff(
          new Date(),
          "days"
        );

      if (certs.next && new Date(certs.next.validTo) >= cdate) daysleft = 365;

      if (daysleft < 0) daysleft = 0;

      return daysleft;
    },
    color: function() {
      const daysleft = this.daysLeft;

      if (daysleft <= 30) return "background-color:red;color:white";
      else if (daysleft <= 60) return "background-color:orange;color:white";
      else if (daysleft <= 90) return "background-color:#ffa50059; color:red";

      return "";
    }
  },

  mounted() {}
};
</script>

<style scoped>
.certificate {
  width: 100%;
  margin-top: 3rem;
}

.certificate-bar {
  width: 100%;
  color: white;

  height: 2.5rem;
  line-height: 2.5rem;
  padding-left: 1rem;
}

.certificate-link {
  color: inherit;
  text-decoration: underline;
}
</style>
